module.exports = __webpack_public_path__ + "img/document.af2822b6.svg";